<div class="booking-container" *ngIf="!loader">
    <div class="heading_sert">
       <sm-title-bar pageTitle="Add new tax configuration" [backWithParams]="true">
       
       </sm-title-bar>
    </div>


    <div class="row">
       <!-- International tax start -->
       <div class="col-md-8" *ngIf="isEntityForeign == '1'">
          <mat-card class="booking-form">
          <div class="inter_set">
            
            <div>
               <mat-form-field appearance="outline">
                  <mat-label>Configuration name</mat-label>
                  <input matInput #input [(ngModel)]="intTaxObj.slab_name">
                 
               </mat-form-field>
            </div>
            <div>
               <mat-form-field appearance="outline">
                  <mat-label>Configuration description</mat-label>
                  <textarea matInput #input [(ngModel)]="intTaxObj.slab_desc"></textarea>
                 
               </mat-form-field>
            </div> 
          
          
           
          <form [formGroup]="taxValueform">
           <div formArrayName="values">
              <div class="row" *ngFor="let item of values.controls; let i = index" [formGroupName]="i">
              <div class="col-sm-5" >
              <mat-form-field appearance="outline">
              <mat-label>Tax name</mat-label>
              <input matInput #input formControlName="tax_name">
              </mat-form-field>
              </div>
              
              <div class="col-sm-6">
              <mat-form-field appearance="outline">
              <mat-label>Tax percentage</mat-label>
              <input matInput #input formControlName="tax_value" smDecimalOnly type="number">   
              </mat-form-field>
              </div>
              <div class="col-sm-1">
                 
                 <span>
                    <mat-icon style="    position: relative;
                    top: 15px;
                    color: #D70D0D; cursor: pointer;
                " (click)="removeFormFieldForValues(i)">delete</mat-icon>
                 </span>
               </div>
              </div>
              
              
              <div class="add_newrt">
              <button mat-flat-button color="primary" (click)="addTaxValueField()"> <mat-icon>add</mat-icon> Add tax value</button>
              </div>
           </div>
          </form> 
          
          </div>
          <div class="cabh_sect">
            <!-- <button  mat-flat-button color="accent" class="resat-btn" >Reset</button> -->
          <button mat-flat-button color="accent" class="submit-btn" [disabled]="taxValueform.invalid" (click)="onSaveInternationalTax()">Save</button>
          </div>
          </mat-card>
          </div>
       <!-- International tax end -->
       <!-- Domestic tax start -->
       <div class="col-sm-8" *ngIf="isEntityForeign == '0'">
          <div class="lsk_cardf">
             <div>
                <mat-form-field appearance="outline">
                   <mat-label>Configuration name</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.tax_name">
                  
                </mat-form-field>
             </div>
             <div>
                <mat-form-field appearance="outline">
                   <mat-label>Configuration description</mat-label>
                   <textarea matInput #input [(ngModel)]="taxObj.tax_desc"></textarea>
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding">
                <div class="item_list_data add_margin_bottom">
                   <span>GST Status</span>
                   <mat-slide-toggle (change)="onToggleChange($event)" [checked]="taxObj.gstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <!-- <div *ngIf="taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>GST Number</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.gstNumber">
                  
                </mat-form-field>
             </div> -->
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
               <div class="item_list_data add_margin_bottom">
                  <span>SGST</span>
                  <mat-slide-toggle (change)="onToggleChangeSGST($event)" [checked]="taxObj.sgstStatus == 1"></mat-slide-toggle>
               </div>
            </div>
            <div *ngIf="taxObj.sgstStatus === 1 && taxObj.gstStatus === 1">
               <mat-form-field appearance="outline">
                  <mat-label>SGST Rate</mat-label>
                  <input matInput #input smDecimalOnly type="number" [(ngModel)]="taxObj.sgstValue">
                 
               </mat-form-field>
            </div>
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
                <div class="item_list_data add_margin_bottom">
                   <span>CGST</span>
                   <mat-slide-toggle (change)="onToggleChangeCGST($event)" [checked]="taxObj.cgstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.cgstStatus === 1 && taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>CGST Rate</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.cgstValue" smDecimalOnly type="number">
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
                <div class="item_list_data add_margin_bottom">
                   <span>IGST</span>
                   <mat-slide-toggle (change)="onToggleChangeIGST($event)" [checked]="taxObj.igstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.igstStatus === 1 && taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>IGST Rate</mat-label>
                   <input matInput #input  smDecimalOnly type="number" [(ngModel)]="taxObj.igstValue">
                  
                </mat-form-field>
             </div>
            
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
                <div class="item_list_data add_margin_bottom">
                   <span>UTGST</span>
                   <mat-slide-toggle (change)="onToggleChangeUTGST($event)" [checked]="taxObj.utgstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.utgstStatus === 1 && taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>UTGST Rate</mat-label>
                   <input matInput #input smDecimalOnly type="number" [(ngModel)]="taxObj.utgstValue">
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding" >
                <div class="item_list_data add_margin_bottom">
                   <span>Service Tax</span>
                   <mat-slide-toggle (change)="onToggleChangeServiceTax($event)" [checked]="taxObj.serviceTaxStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.serviceTaxStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>Service Tax Rate</mat-label>
                   <input matInput #input smDecimalOnly type="number" [(ngModel)]="taxObj.serviceTaxValue">
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding" >
                <div class="item_list_data add_margin_bottom">
                   <span>Other Tax</span>
                   <mat-slide-toggle (change)="onToggleChangeOtherTax($event)" [checked]="taxObj.otherTaxStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div  *ngIf="taxObj.otherTaxStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>Other Tax Name</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.otherTaxName">
                  
                </mat-form-field>
             </div>
             <div *ngIf="taxObj.otherTaxStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>Other Tax Rate</mat-label>
                   <input matInput #input smDecimalOnly type="number" [(ngModel)]="taxObj.otherTax">
                  
                </mat-form-field>
             </div>
             <div class="cabh_sect">
              <!-- <button  mat-flat-button color="accent" class="resat-btn" (click)="onReset()">Reset</button> -->
            <button mat-flat-button color="accent" class="submit-btn" [disabled]="
            !taxObj.tax_name
            " (click)="onSubmitTaxDetails()">Save</button>
            </div>
          </div>
       </div>
       <!-- Domestic tax end -->
       <div class="col-md-4 booking-sidebar">
         <div class="faq" *ngIf="isEntityForeign == '0'">
            <mat-accordion>
               <mat-expansion-panel [expanded]="panelState[0]" (opened)="panelState[0] = true" (closed)="panelState[0] = false">
               <mat-expansion-panel-header>
                  <mat-panel-title>
                   Is Tax configuration is compulsory for all? 
                  </mat-panel-title>
               </mat-expansion-panel-header>
               <p>No. It's optional. You can enable Tax and configure it only if you are authorized to pay taxes for your service. 
               </p>
               </mat-expansion-panel>
               <mat-expansion-panel (opened)="panelState[1] = true"
               (closed)="panelState[1] = false">
               <mat-expansion-panel-header>
                  <mat-panel-title>
                   What is Tax Identifiers?
                  </mat-panel-title>
               </mat-expansion-panel-header>
               <p>The tax identifiers are issued to businesses and individuals by Government and Local authorities. These can be numbers or id varied based upon country and issuing authority.  
               </p>
               </mat-expansion-panel>
               <mat-expansion-panel (opened)="panelState[2] = true"
               (closed)="panelState[2] = false">
               <mat-expansion-panel-header>
                  <mat-panel-title>
                   What is Bill/Invoice type?
                  </mat-panel-title>
               </mat-expansion-panel-header>
               <p>Tax can be added in 2 ways in an invoices/bill- Inclusive and Exclusive. In inclusive type, the taxes are already added in the final selling price of the services or products. Inclusive rates will always include tax in the total that you see in the unit price. In exclusive type, the selling price of services or products are getting shown without any added tax. Here the tax added separately while producing the bill/invoice.   
               </p>
               </mat-expansion-panel>
               <mat-expansion-panel (opened)="panelState[3] = true"
               (closed)="panelState[3] = false">
               <mat-expansion-panel-header>
                  <mat-panel-title>
                   How to configure different Tax slabs?
                  </mat-panel-title>
               </mat-expansion-panel-header>
               <p>You can configure several tax slabs based on requirement. It can be service specific or selling product specific. Add tax components, configure rates and give a name to these slabs. Apply these tax configurations/slabs to the services and products.
               </p>
               </mat-expansion-panel>
               <mat-expansion-panel (opened)="panelState[4] = true"
               (closed)="panelState[4] = false">
               <mat-expansion-panel-header>
                  <mat-panel-title>
                   Do I need to add the Tax against each service or selling item?
                  </mat-panel-title>
               </mat-expansion-panel-header>
               <p> If the service or product you are selling is taxable, then you need to add a specific tax configuration/slab with it. This can be done during the time of creating the service/product or while editing them.
               </p>
               </mat-expansion-panel>
               <mat-expansion-panel (opened)="panelState[5] = true"
               (closed)="panelState[5] = false">
               <mat-expansion-panel-header>
                  <mat-panel-title>
                   Where these Tax information will show up?
 
                  </mat-panel-title>
               </mat-expansion-panel-header>
               <p>You and your customer can see these Tax information and the collected amount in the invoices. In the 'Tax collection' segment of the 'Reports' section, you can see detail data on it. There you can see tabular data as well graph chart. 
               </p>
               </mat-expansion-panel>
            </mat-accordion>
         </div>
        <!--  -->
        <div class="faq" *ngIf="isEntityForeign == '1'">
           <mat-accordion>
              <mat-expansion-panel [expanded]="panelState[0]" (opened)="panelState[0] = true" (closed)="panelState[0] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                  Is Tax configuration is compulsory for all? 
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>No. It's optional. You can enable Tax and configure it only if you are authorized to pay taxes for your service. 
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[1] = true"
              (closed)="panelState[1] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                  What is Tax Identifiers?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>The tax identifiers are issued to businesses and individuals by Government and Local authorities. These can be numbers or id varied based upon country and issuing authority.  
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[2] = true"
              (closed)="panelState[2] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                  What is Bill/Invoice type?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Tax can be added in 2 ways in an invoices/bill- Inclusive and Exclusive. In inclusive type, the taxes are already added in the final selling price of the services or products. Inclusive rates will always include tax in the total that you see in the unit price. In exclusive type, the selling price of services or products are getting shown without any added tax. Here the tax added separately while producing the bill/invoice.   
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[3] = true"
              (closed)="panelState[3] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                  How to configure different Tax slabs?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>You can configure several tax slabs based on requirement. It can be service specific or selling product specific. Add tax components, configure rates and give a name to these slabs. Apply these tax configurations/slabs to the services and products.
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[4] = true"
              (closed)="panelState[4] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                  Do I need to add the Tax against each service or selling item?
                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p> If the service or product you are selling is taxable, then you need to add a specific tax configuration/slab with it. This can be done during the time of creating the service/product or while editing them.
              </p>
              </mat-expansion-panel>
              <mat-expansion-panel (opened)="panelState[5] = true"
              (closed)="panelState[5] = false">
              <mat-expansion-panel-header>
                 <mat-panel-title>
                  Where these Tax information will show up?

                 </mat-panel-title>
              </mat-expansion-panel-header>
              <p>You and your customer can see these Tax information and the collected amount in the invoices. In the 'Tax collection' segment of the 'Reports' section, you can see detail data on it. There you can see tabular data as well graph chart. 
              </p>
              </mat-expansion-panel>
           </mat-accordion>
        </div>
     </div>
  
  
  
       
    </div>
  </div>